export default "__VITE_ASSET__DeU0rDEI__"